import { UPDATE_RESSOURCES } from "Redux/Actions/ressourcesActions";

const INITIAL_STATE = {
  ressourcesData: [],
};

const ressourcesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_RESSOURCES: {
      return {
        ...state,
        ...action.value,
      };
    }
    default:
      return state;
  }
};

export default ressourcesReducer;
